import React from 'react';
import { Grid, Card, CardContent, CardHeader, CardActions, List, ListItemIcon, ListItemText, Container, Checkbox, Button, SvgIcon, Tooltip, ListItemButton, } from '@mui/material';
import { ESMVALBASEURL } from '../../App/ApplicationConfig';
const classes = {
    root: {
        flex: 1,
    },
    list: {
        margin: '0px',
    },
    listItem: {
        margin: '0px',
        padding: '0px',
    },
    listItemIcon: {
        minWidth: '0px',
        height: '1em',
    },
    icon: {
        marginRight: '16px',
    },
    cardGrid: {
        paddingTop: '0px',
        paddingBottom: '0px',
        maxWidth: 'auto',
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '15em',
        minWidth: '12em',
    },
    cardMedia: {
        title: {
            fontSize: '1em',
        },
        paddingLeft: '3rem',
    },
    cardContent: {
        flexGrow: 0,
        overflow: 'auto',
        maxHeight: '450px',
    },
    numResults: {
        color: '#888',
    },
    tooltip: {
        fontSize: '0.75rem',
    },
};
/**
 * For a certain facet (variable, model, experiment) and a certain facetfield (tas, hus) return the long description
 * @param facetId (variable, model, experiment)
 * @param fieldId (tas, hus)
 */
const getLongNames = (descriptions, fieldId) => {
    if (!descriptions || !fieldId)
        return fieldId;
    return descriptions[fieldId] ? descriptions[fieldId].title : fieldId;
};
const FacetSelector = ({ searchQuery, changeFacetField, facetType, searchFacetResults, enableAdvancedView, searchResultMask, }) => {
    var _a;
    const { config: facetConfiguration } = facetType;
    const handleToggle = (value) => () => {
        const checked = searchQuery.selectedItems.filter((item) => item.facetId === facetType.id && item.fieldId === value).length > 0;
        if (changeFacetField) {
            changeFacetField(facetType.id, value, !checked);
        }
    };
    const facetSearchResult = searchFacetResults && searchFacetResults[facetType.id];
    const renderList = (items, searchQueryArg, facetTypeArg, extendedView) => {
        const augmentedItems = items.map((item) => {
            return {
                id: item.id,
                title: item.title,
                numResults: facetSearchResult ? facetSearchResult[item.id] : -1,
            };
        });
        // sort alphabetically on title or id
        const sortedItems = augmentedItems.sort((a, b) => {
            return extendedView
                ? a.id.localeCompare(b.id)
                : a.title.localeCompare(b.title);
        });
        return (React.createElement("div", { style: classes.root },
            React.createElement(List, { sx: classes.list }, sortedItems.map((item) => {
                const labelId = `checkbox-list-label-${item.id}`;
                const numResultsForFacetField = facetSearchResult && facetSearchResult[item.id]
                    ? facetSearchResult[item.id]
                    : -1;
                const numFacet = numResultsForFacetField > 0 ? numResultsForFacetField : '-';
                return (React.createElement(ListItemButton, { disabled: numResultsForFacetField === -1, sx: classes.listItem, key: item.id, role: undefined, dense: true, onClick: handleToggle(item.id) },
                    React.createElement(ListItemIcon, { sx: classes.listItemIcon },
                        React.createElement(Checkbox, { edge: 'start', checked: searchQueryArg &&
                                searchQueryArg.selectedItems.filter((selectedItem) => selectedItem.facetId === facetTypeArg.id &&
                                    selectedItem.fieldId === item.id).length > 0, tabIndex: -1, disableRipple: true, inputProps: { 'aria-labelledby': labelId }, color: 'primary' })),
                    React.createElement(ListItemText, { id: labelId, primary: `${item.id} - ${item.title}` }),
                    React.createElement("span", { style: classes.numResults }, `(${numFacet})`)));
            }))));
    };
    /**
     * Creates a FacetFieldType[] from the given facetSearchResult, facetSearchResult come from the ESGF search query.
     * @param facetDescriptions
     * @param facetSearchResultArg
     */
    const makeItemsFromFacetSearchResult = (facetDescriptions, facetSearchResultArg, advancedView, facetSearchResultMask) => {
        if (facetConfiguration[0].descriptions && !advancedView) {
            return Object.keys(facetConfiguration[0].descriptions).map((item) => {
                return { id: item, title: getLongNames(facetDescriptions, item) };
            });
        }
        // modification to show all possible search results in case of extended view
        if (advancedView && facetSearchResultMask) {
            return Object.keys(facetSearchResultMask).map((item) => {
                return { id: item, title: getLongNames(facetDescriptions, item) };
            });
        }
        // keep original method as fallback - this one does
        // filter out results in the list where no data is available
        return Object.keys(facetSearchResultArg).map((facet) => {
            return { id: facet, title: getLongNames(facetDescriptions, facet) };
        });
    };
    const isModelFacet = facetType.id === 'source_id' || facetType.id === 'model';
    const selectedOfFacetType = searchQuery.selectedItems.filter((selectedItem) => selectedItem.facetId === facetType.id);
    const selectedProject = (_a = searchQuery.selectedItems.find((selectedItem) => selectedItem.facetId === 'project')) === null || _a === void 0 ? void 0 : _a.fieldId;
    const facetScopedSearchResultMask = searchResultMask
        ? searchResultMask[facetType.id]
        : null;
    return (React.createElement(Container, { sx: classes.cardGrid },
        React.createElement(Grid, { container: true, sx: { justifyContent: 'center' }, spacing: 4 }, (enableAdvancedView
            ? [
                {
                    title: facetType.title,
                    description: 'all',
                    tooltip: 'all',
                    titleBGColor: facetConfiguration[0].titleBGColor,
                    items: null,
                    descriptions: facetConfiguration[0].descriptions,
                },
            ]
            : facetConfiguration).map((card) => (React.createElement(Grid, { item: true, key: card.title, xs: 12, sm: 6, md: enableAdvancedView ? 12 : facetType.gridMd || 3 },
            React.createElement(Card, { sx: classes.card, raised: true },
                React.createElement(SvgIcon, { style: {
                        float: 'right',
                        overflow: 'none',
                        position: 'absolute',
                        color: 'white',
                        margin: '20px 30px auto 1rem',
                    } },
                    ' ',
                    React.createElement("path", { d: card.icon })),
                React.createElement(CardHeader, { sx: classes.cardMedia, title: card.title, style: {
                        backgroundColor: card.titleBGColor,
                        color: 'white',
                    } }),
                React.createElement(CardContent, { sx: classes.cardContent }, card.items && card.items.length > 0
                    ? renderList(card.items, searchQuery, facetType, enableAdvancedView)
                    : renderList(makeItemsFromFacetSearchResult(card.descriptions || {}, facetSearchResult || {}, enableAdvancedView, facetScopedSearchResultMask), searchQuery, facetType, enableAdvancedView)),
                isModelFacet &&
                    selectedProject &&
                    ['CMIP6', 'CMIP5'].includes(selectedProject) && (React.createElement(CardActions, null,
                    React.createElement(Tooltip, { sx: { '& .MuiTooltip-tooltip': classes.tooltip }, title: 'Interactive comparison of models\u2019 bias and projected changes on Temperature and Precipitation variables.' },
                        React.createElement(Button, { size: 'small', color: 'primary', onClick: () => {
                                const url = `${ESMVALBASEURL}?project=${selectedProject}${selectedOfFacetType
                                    .map((selectedItem) => `&dataset=${selectedItem.fieldId}`)
                                    .join('')}`;
                                window.open(url, '_blank');
                            } }, "Compare model performance")))))))))));
};
export default FacetSelector;
